import { twMerge } from "tailwind-merge";
import loader from "@assets/classic_loader.svg";

interface IClassicLoaderProps {
  className?: string;
}

/**
 * Old loader from old web
 */
export const ClassicLoader: React.FC<IClassicLoaderProps> = (props) => {
  const { className } = props;

  return (
    <div className={twMerge("size-10", className)}>
      <img src={loader} />
    </div>
  );
};
